module.exports = "https://img.zhijierongxing.com/saas/img/sales_amount.a0bb1268.png";